#import "../../../../graphql/fragments/sales-automation-stageset.graphql"

mutation CreateClosedLeadFollowupAutomation($input: FollowupLeadAutomationCreateInput!) {
    followupLeadAutomationCreate(input: $input) {
        stageset {
            ...SalesAutomationStageset
        }
    }
}
